export default __webpack_public_path__ + "static/media/colour-logo.a23433a2.png";